import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AdminTableComponent from 'routes/Admin/components/CommonComponents/AdminTableComponent'
import {
  MODAL_ADMIN_EDIT_LOCKER,
  MODAL_ADMIN_CREATE_LOCKER,
  MODAL_ADMIN_DELETE_LOCKER
} from 'redux/modules/modals'
const clientTransform = value => {
  return value
    ? `${value.customers_last_name} ${value.customers_first_name}`
    : '-'
}
const defaultColumnData = [
  { id: 'name', numeric: false, disablePadding: true, label: 'Nom' },
  {
    id: 'customer',
    numeric: false,
    disablePadding: false,
    label: 'Client',
    transform: clientTransform
  },
  { id: 'available', bool: true, disablePadding: false, label: `Disponible` },
  {
    id: 'expirationDate',
    expiration: true,
    disablePadding: true,
    label: `Date d'expiration`
  }
]
export default class AdminLockersComponent extends Component {
  static propTypes = {
    lockers: PropTypes.array.isRequired,
    showModal: PropTypes.func.isRequired
  }
  handleAddLockerClick = () => {
    this.props.showModal(MODAL_ADMIN_CREATE_LOCKER)
  }
  handleEditLockerClick = locker => {
    this.props.showModal(MODAL_ADMIN_EDIT_LOCKER, locker)
  }
  handleDeleteLockerClick = locker => {
    this.props.showModal(MODAL_ADMIN_DELETE_LOCKER, locker)
  }

  render() {
    const { lockers } = this.props
    return (
      <div style={{ paddingTop: 24 }}>
        <AdminTableComponent
          title="Casiers"
          search={['name']}
          list={lockers}
          selectable
          orderBy={'name'}
          columnData={defaultColumnData}
          addButtonAction={this.handleAddLockerClick}
          editButtonAction={this.handleEditLockerClick}
          deleteButtonAction={
            lockers.length === 1 ? null : this.handleDeleteLockerClick
          }
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/Admin/Lockers/components/LockersComponent.js